import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { Confirm, ConfirmButton, MessageService } from '..';

@Component({
  selector: 'confirm',
  templateUrl: './confirm.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ConfirmComponent implements OnInit {
  public confirm?: Confirm;

  private dialogRef?: MatDialogRef<any>;

  @ViewChild('modal') modal?: TemplateRef<any>;

  constructor(private messageService: MessageService, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.messageService.onConfirm.subscribe((confirm: Confirm) => {
      if (this.modal) {
        this.confirm = confirm;

        this.dialogRef = this.dialog.open(this.modal, {
          disableClose: true,
        });

        this.dialogRef.afterClosed().subscribe(() => {
          delete this.confirm;
          delete this.dialogRef;
        });
      }
    });
  }

  public onConfirm(action: ConfirmButton): void {
    if (action.handler) {
      action.handler();
    }

    this.dialogRef?.close();
  }

  public onClose(): void {
    const actions = this.actions.filter((action: ConfirmButton) => action.close);

    actions.forEach((action: ConfirmButton) => {
      if (action.handler) {
        action.handler()
      }
    });

    this.dialogRef?.close();
  }

  public get actions(): ConfirmButton[] {
    return this.confirm?.buttons || [];
  }
}
